import { makeAutoObservable, runInAction } from 'mobx'
import { MktuClass, RegistrySearchItem } from '@/services/Api/generated'
import { RegistryShort } from '@/services/Api/generated/models/RegistryShort'
import {
  getRegistriesRequestData,
  getRegistry,
  searchRegistriesSite,
} from '@/services/Api/actions/registries/actions'
import { Loader } from '@/helpers/Loader'
import { toast } from 'react-toastify'

type registryItemsLoaderParams = {
  requestData: getRegistriesRequestData
  captcha: string | null
}

export class OnlineSearchStore {
  searchString: string = ''
  selectedMktuClassesNumbers: MktuClass['classNumber'][] = []
  registrySearchItems: RegistrySearchItem[] = []
  total: number = 0
  isActualParams: boolean = false

  mktuClassShowInfo: MktuClass | null = null

  registryInfo: RegistryShort | null = null

  registryItemsLoader = new Loader(
    async (params: registryItemsLoaderParams) => {
      try {
        const response = await searchRegistriesSite(
          params.requestData,
          params.captcha
        )
        if (response.status) {
          if ('pagination' in response) {
            const paginationData = response.pagination
            if (typeof paginationData !== 'undefined') {
              runInAction(() => {
                this.total = paginationData.total || 0
              })
            }
          }

          if ('data' in response) {
            return response.data
          }
        }
        return null
      } catch (error) {
        return null
      }
    }
  )

  registryInfoLoafer = new Loader(async (registryNumber: string) => {
    try {
      const responseData = await getRegistry(registryNumber)
      if (responseData.status && 'data' in responseData) {
        return responseData.data
      }
      return null
    } catch (error) {
      return null
    }
  })

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  toggleSelectedMktuClassInfo(mktuClass: MktuClass) {
    if (mktuClass.classNumber == this.mktuClassShowInfo?.classNumber) {
      this.mktuClassShowInfo = null
    } else {
      this.mktuClassShowInfo = mktuClass
    }
  }

  toggleSelectedMktuClassNumber(mktuClass: MktuClass) {
    if (this.selectedMktuClassesNumbers.includes(mktuClass.classNumber)) {
      this.selectedMktuClassesNumbers = this.selectedMktuClassesNumbers.filter(
        (i) => i !== mktuClass.classNumber
      )
    } else {
      this.selectedMktuClassesNumbers = [
        ...this.selectedMktuClassesNumbers,
        mktuClass.classNumber,
      ]
    }
    this.isActualParams = false
  }

  deleteSelectedMktuClassNumber(classNum: number) {
    this.selectedMktuClassesNumbers = this.selectedMktuClassesNumbers.filter(
      (i) => i !== classNum
    )
    this.isActualParams = false
  }

  setMktuClassShowInfo(selectedClass: MktuClass | null) {
    this.mktuClassShowInfo = selectedClass
  }

  async loadRegistryItems(searchString: string, captcha: string | null) {
    if (this.isActualParams && searchString == this.searchString) {
      return
    }

    runInAction(() => {
      this.registrySearchItems = []
      this.total = 0
    })

    const requestData: getRegistriesRequestData = {
      name: searchString,
    }

    if (this.selectedMktuClassesNumbers.length > 0) {
      requestData.mktuClasses = this.selectedMktuClassesNumbers.join(',')
    }

    const loadResult = await this.registryItemsLoader.request({
      requestData,
      captcha,
    })

    if (loadResult != null) {
      runInAction(() => {
        this.searchString = searchString
        this.registrySearchItems = loadResult
      })
    } else {
      toast.error('Что то пошло не так! Попробуйте позже')
    }
  }

  async loadRegistryInfo(registry: RegistrySearchItem) {
    if (
      this.registryInfo != null &&
      this.registryInfo.registrationNumber === registry.number
    ) {
      return
    }

    runInAction(() => {
      this.registryInfo = null
    })

    const registryInfo = await this.registryInfoLoafer.request(
      'TM-' + registry.folderName + registry.number
    )

    if (registryInfo != null) {
      runInAction(() => {
        this.registryInfo = registryInfo
      })
    } else {
      toast.error('Что то пошло не так! Попробуйте позже')
    }
  }
}

export const onlineSearchStore = new OnlineSearchStore()
